import { CompGroupData } from './CompGroupLabel.types';

export interface CompGroupTooltipContent {
  name: string;
  automaticUpdatesLabel: string | null;
}

const getCompGroupTooltipContent = (compGroupData: CompGroupData): CompGroupTooltipContent => {
  const { use_latest_comp_group_version: useLatestVersion, name } = compGroupData;
  const automaticUpdatesLabel =
    useLatestVersion === undefined ? null : `Automatic updates: ${useLatestVersion ? 'Yes' : 'No'}`;

  return {
    name,
    automaticUpdatesLabel,
  };
};

export default getCompGroupTooltipContent;
